import guest from './rules/guest';
import auth from './rules/auth';

export default {
    guest, auth
}